module.exports = __webpack_public_path__ + "img/62.1f12cd0b.jpg";